import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, takeLatest } from 'redux-saga/effects';
import { i18n } from '../../translations';
import { getAffinyPlaceId } from '../api';
import {
  EMapsActionType,
  IGetAffinyPlaceIdAction,
  IGetMapsAction,
} from './actions';
import { ICity } from './types';
import { AffinyEndpoint } from 'affiny-core/modules/api/core/affinyEndpoints/affiny.endpoints';
import { ICitiesApiResult } from 'affiny-core/modules/maps/types';
import { logger } from 'affiny-core/logger';

const MAX_CITIES_RESULTS = 5;

export const getPhotonPredictions = async (searchText: string) => {
  try {
    const results = (await AffinyEndpoint.Geo.url('/predictions/forward')
      .query({ term: searchText })
      .get()
      .json()) as ICitiesApiResult;

    return results.predictions.length > 0
      ? results.predictions.slice(0, MAX_CITIES_RESULTS).map(city => ({
          id: city.provider_place_id,
          lat: city.latitude,
          lng: city.longitude,
          postcode: city.postcode,
          country: city.country_name,
          // when the language is not set in the Algolia query (eg. no SIM), the locale_names object contains a default value
          name: Array(city.name),
        }))
      : undefined;
  } catch (e) {
    logger.log('predictions error', e);

    return undefined;
  }
};

export function* getMapsSaga(action: IGetMapsAction) {
  const response: ICity[] | undefined = action.payload.text
    ? yield call(getPhotonPredictions, action.payload.text)
    : [];

  if (response) {
    yield call(action.payload.formikActions.setFieldValue, 'cities', response);
  } else {
    yield call(
      action.payload.formikActions.setFieldError,
      'place',
      i18n.translate('errors.MEMBERS_GEO_PLACE_ID_NOT_EXISTS')
    );
  }
}

export function* getAffinyPlaceIdSaga(action: IGetAffinyPlaceIdAction) {
  const response = yield call(
    getAffinyPlaceId,
    action.payload.item.id,
    action.payload.item.lat,
    action.payload.item.lng
  );

  yield call(
    action.payload.formikActions.setFieldValue,
    'placeId',
    response.data[0].id
  );
  yield call(
    action.payload.formikActions.setFieldValue,
    'place',
    action.payload.item.name
  );
}

export function* mapsRootSaga() {
  yield all([
    takeLatest(
      EMapsActionType.GET_PREDICTIONS,
      handleAsyncStatus(getMapsSaga, EAsyncEventTypes.MAPS_AUTOCOMPLETE, true)
    ),
    takeLatest(
      EMapsActionType.GET_CONVERTED_PLACE_ID,
      handleAsyncStatus(getAffinyPlaceIdSaga, EAsyncEventTypes.MAPS_PLACE, true)
    ),
  ]);
}
